"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Popup_1 = __importDefault(require("../../client/reusable_components/Popup"));
const icon_1 = __importDefault(require("../../client/icon"));
const buttons_css_1 = __importDefault(require("../../styles/global_ui/buttons.css"));
const typography_css_1 = __importDefault(require("../../styles/global_ui/typography.css"));
const style_css_1 = __importDefault(require("./style.css"));
const Tip = ({ onClick }) => (react_1.default.createElement("div", { className: style_css_1.default.tip },
    "Entries are calculated and updated once per day. See",
    ' ',
    react_1.default.createElement("span", { className: typography_css_1.default.linkBlue, onClick: onClick }, "rules"),
    ' ',
    "to learn more."));
const EarnedEntries = ({ entries, setActiveTab }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("span", null,
        entries,
        ' ',
        entries > 1 ? 'entries' : 'entry',
        ' ',
        "earned"),
    react_1.default.createElement(Popup_1.default, { align: "center", classList: { trigger: `${buttons_css_1.default.unset} ${buttons_css_1.default.xs} ${style_css_1.default.triggerIcon}` }, hasArrow: true, side: "bottom", trigger: react_1.default.createElement(icon_1.default, { name: "info-circle", size: 16 }) },
        react_1.default.createElement(Tip, { onClick: () => setActiveTab('rules') }))));
exports.default = EarnedEntries;
